import s from './style.css';

const SectionTitle = ({ title }) => (
	<div className={s.sectionTitleWrapper}>
		<h2 className={s.title}>{title}</h2>
	</div>
);

export default SectionTitle;



// WEBPACK FOOTER //
// ./components/SectionTitle/index.js